import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import SelectorValueMaps from 'src/components/insigth/SelectorValueMaps';
import MapValueCardGraph from 'src/components/insigth/MapValueCardGraph';
import ComparisionTableMapValue from '../ComparisionTableMapValue';

const CompareMapsValues = ({
  classes,
  compare,
  mapValue,
  functionPrint,
  totalMapsValue,
  dataSetGenerator,
  handleCloseCompare,
}) => {
  const [selectedLeft, setSelectedLeft] = useState(mapValue);
  const [selectedRight, setSelectedRight] = useState(mapValue);

  const onSelectLeft = (value) => {
    setSelectedLeft({
      ...value,
    });
  };

  const onSelectRight = (value) => {
    setSelectedRight({
      ...value,
    });
  };

  return (
    <>
      <Dialog
        id="modal-print"
        open={compare}
        maxWidth="xl"
        fullWidth
        onClose={handleCloseCompare}
        aria-labelledby="title"
        aria-describedby="description"
      >
        <DialogTitle id="title">
          <section className={classes.selector}>
            <SelectorValueMaps
              mapValue={selectedLeft}
              stateEdit
              totalMapsValue={totalMapsValue}
              handleSelectMapValue={onSelectLeft}
            />
            <SelectorValueMaps
              mapValue={selectedRight}
              stateEdit
              totalMapsValue={totalMapsValue}
              handleSelectMapValue={onSelectRight}
            />
          </section>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <MapValueCardGraph
                height={50}
                width={100}
                classes={classes}
                title="Unidades Mes"
                data={dataSetGenerator(selectedLeft, 'unidades')}
              />
              <ComparisionTableMapValue
                classes={classes}
                array={selectedLeft}
              />
            </Grid>
            <Grid item xs={6}>
              <MapValueCardGraph
                height={50}
                width={100}
                classes={classes}
                title="Unidades Mes"
                data={dataSetGenerator(selectedRight, 'unidades')}
              />
              <ComparisionTableMapValue
                classes={classes}
                array={selectedRight}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions id="buttons-print">
          <Button onClick={functionPrint} color="github">
            Imprimir
          </Button>
          <Button onClick={handleCloseCompare} color="github" autoFocus>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CompareMapsValues;
